import { Form as SemanticForm } from 'semantic-ui-react';
import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent,
  Loader as LoaderLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  width: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 768px;
  padding: 50px 10px;
`;

const WrapperContainer = styled.div`
  width: auto;
  display: block;
  max-width: 768px;
  padding: 50px 10px;
  margin: 0 auto;
`;

const MainContainer = styled.div`
  border: 1px solid ${(props) => props.theme.color.segmentBorder};
  box-shadow: none;
  margin: 0px;
  min-height: 160px;
`;

const DisqualifiedLabel = styled.h1`
  margin: 0;
`;

const DisqualifiedContainer = styled.div`
  border: 1px solid ${(props) => props.theme.color.segmentBorder};
  box-shadow: none;
  margin: 0px;
  min-height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled(TextLayoutComponent.Title)`
  padding-top: 20px;
  padding-right: 80px;
  padding-bottom: 5px;
  padding-left: 80px;

  @media (max-width: 800px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const Subtitle = styled(TextLayoutComponent)`
  padding-right: 80px;
  padding-bottom: 5px;
  padding-left: 80px;

  @media (max-width: 800px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const Logo = styled.img`
  max-width: 190px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-bottom: 50px;
`;

const SurveyForm = styled(SemanticForm)`
  margin-left: 80px;
  margin-right: 80px;

  @media (max-width: 800px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

const FullWidth = styled.div`
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const BottomButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 120px;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.color.textError};
  :first-child {
    margin-top: 20px;
    margin-bottom: 30px;
  }
`;

const BlueStrip = styled.div`
  background-color: ${(props) => props.theme.color.primary};
  height: 12px;
`;

const Loader = styled(LoaderLayoutComponent).attrs((props) => ({
  ...props,
  inline: false,
}))``;

const Link = styled.a`
  margin-left: 80px;
  margin-right: 80px;

  @media (max-width: 800px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export {
  Container,
  WrapperContainer,
  MainContainer,
  Title,
  Subtitle,
  Logo,
  SurveyForm,
  FullWidth,
  BottomButton,
  ErrorMessage,
  BlueStrip,
  Loader,
  DisqualifiedLabel,
  DisqualifiedContainer,
  Link,
};
